<template>
  <div class="w_inner">
    <div class="innerWrap">
        <div class="MProShowCon">
      <div class="breadmapShow">
        <div class="bread-wrapper">
          <span><router-link :to="{ name: 'mhome' }">{{ $t('product.nav') }}</router-link></span>
          <span>{{ dto.title }}</span>
        </div>
      </div>
      <div class="main_container">
        <template v-for="(item, index) in procontent">
          <div :class="'about_desc ' + (index % 2 == 0 ? 'color_white' : 'color_blue')">
            <div class="atitle wow fadeInUp animated">
              {{ item.title }}
            </div>
            <div class="desc_box clearfix">
              <div class="imgShow wow fadeInUp animated" data-wow-delay="0.2s">
                <img :src="item.img" alt="">
              </div>
              <div class="testShow">
                <div class="descCon wow fadeInUp animated" data-wow-delay="0.2s">
                  <p style="color: #333;font-weight: bold;font-size: 34px;padding-bottom:12px">
                    {{ item.subTitle }}
                  </p>
                  <p>{{ item.content }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>
        
      
      </div>
    </div>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex';
import WOW from "../../../node_modules/wowjs/dist/wow";
export default {
  data() {
    return {
      id: this.$route.params.id,
      dto: {},
      procontent: [],
      currentLang: this.$i18n.locale
    }
  },
  computed: {
    ...mapState({
      CategoryList: state => state.CategoryList
    })
  },
  mounted() {
    //滚动页面加载动画
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    document.documentElement.scrollTop = 0;
  },
  created: function () {
    this.GetProInfo();
  },
  methods: {
    GetProInfo() {
      var url = "/pageapi/Product/GetDetail";
      this.$http.post(url, { id: this.$route.params.id }).then(function (res) {
        if (res.data.status == 1) {
          this.procontent = JSON.parse(res.data.ds.content);
          this.dto = res.data.ds;
          this.$nextTick(function () {
            this.Initwow();
          });
          // console.log(this.procontent);
        }
      }.bind(this)).catch(function () {
      });
    },
    Initwow() {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }
  },
};
</script>
